module.exports = __webpack_public_path__ + "images/_/programs/zeroHeroes/images/level-4_start-1eca31c035bdfd4aa4017d79a8328323.png";


//////////////////
// WEBPACK FOOTER
// ./programs/zeroHeroes/images/level-4_start.png
// module id = 451
// module chunks = 2